import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newlineToBr',
  standalone: true,
  pure: true,
})
export class NewlineToBrPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value) {
      return '';
    }
    return value.replace(/\n/g, '<br>');
  }
}
